import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@mui/material';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckOutlined } from '@mui/icons-material';
import AddNewTask from '.';
import BDrawer from '@ui/components/common/BDrawer/BDrawer';
const AddTaskDrawer = ({ drawerOpen, setDrawerClose, isCreateAllowed }) => {
    const { t } = useTranslation();
    const formRef = useRef(null);
    const handleSubmit = () => {
        if (formRef.current) {
            formRef.current.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
    };
    return (_jsx(BDrawer, { anchor: 'bottom', open: drawerOpen, title: t('tasks.addNewTask'), onClose: setDrawerClose, dialogActions: _jsxs(_Fragment, { children: [_jsx(Button, { fullWidth: true, onClick: setDrawerClose, variant: 'outlined', color: 'inherit', size: 'large', children: t('actions.cancel') }), _jsx(Button, { fullWidth: true, variant: 'contained', color: 'inherit', size: 'large', startIcon: _jsx(CheckOutlined, {}), onClick: handleSubmit, children: t('actions.createTask') })] }), children: _jsx(AddNewTask, { dialog: true, isDrawer: true, isCreateAllowed: isCreateAllowed, onClose: setDrawerClose, formRef: formRef }) }));
};
export default AddTaskDrawer;
